export const DOMAIN_CONFIG = {
  PRODUCTION: 'gcctaxlaws.com',
  EMPTY_COUNTRY_DEFAULT_HOSTS: [
    'gcctaxlaws.com',
    'www.gcctaxlaws.com',
    'cra.uaetaxlaws.com',
    'www.cra.uaetaxlaws.com',
    'payments.uaetaxlaws.com',
    'www.payments.uaetaxlaws.com',
  ],
  COUNTRY_SPECIFIC: [
    'uaetaxlaws.com',
    'ksataxlaws.com',
    'kuwaittaxlaws.com',
    'qatartaxlaws.com',
    'omantaxlaws.com',
    'bahraintaxlaws.com',
  ],
}

export const getDomainInfo = () => {
  const hostname = window.location.hostname

  return {
    hostname,
    isLocalDevelopment: isLocalDevelopment(hostname),
    isProduction: isProduction(hostname),
    isCountrySpecific: isCountrySpecific(hostname),
    shouldShowCountrySelector: shouldShowCountrySelector(hostname),
    shouldDefaultCountryToEmpty: shouldDefaultCountryToEmpty(hostname),
    getCountryFromDomain: getCountryFromDomain(hostname),
  }
}

export const isLocalDevelopment = (hostname = window.location.hostname) => {
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.match(/^192\.168\.\d+\.\d+$/) ||
    hostname.match(/^10\.\d+\.\d+\.\d+$/) ||
    hostname.match(/^172\.(1[6-9]|2[0-9]|3[0-1])\.\d+\.\d+$/)
  )
}

export const isProduction = (hostname = window.location.hostname) => {
  return DOMAIN_CONFIG.EMPTY_COUNTRY_DEFAULT_HOSTS.includes(hostname)
}

export const isCountrySpecific = (hostname = window.location.hostname) => {
  return DOMAIN_CONFIG.COUNTRY_SPECIFIC.includes(hostname)
}

export const shouldShowCountrySelector = (
  hostname = window.location.hostname
) => {
  return isLocalDevelopment(hostname) || isProduction(hostname)
}

export const shouldDefaultCountryToEmpty = (
  hostname = window.location.hostname
) => {
  return (
    isLocalDevelopment(hostname) ||
    DOMAIN_CONFIG.EMPTY_COUNTRY_DEFAULT_HOSTS.includes(hostname)
  )
}

export const getCountryFromDomain = (hostname = window.location.hostname) => {
  const domainToCountryMap = {
    'uaetaxlaws.com': 'UAE',
    'ksataxlaws.com': 'KSA',
    'kuwaittaxlaws.com': 'Kuwait',
    'qatartaxlaws.com': 'Qatar',
    'omantaxlaws.com': 'Oman',
    'bahraintaxlaws.com': 'Bahrain',
  }

  return domainToCountryMap[hostname] || null
}
